import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useCashBalance = () => useQuery({ queryKey: [`distributor-cash-balance`], queryFn: async () => {
    const callback = await API.get(`/cash/balance`)
    return callback?.data
}, staleTime: 1000 * 60, gcTime: 1000 * 60 * 60 * 60 * 24 })

export default useCashBalance